// extracted by mini-css-extract-plugin
export default {"border":"dy_mt","borderInvalid":"dy_mv","label":"dy_mw","labelFocused":"dy_mx"};